import { Trash2 } from 'lucide-react';

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from '@nesso/ui/primitives/alert-dialog';
import { Button } from '@nesso/ui/primitives/button';

import { formatRelativeDays } from '@/shared/lib/time-utils';

type Props = {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onDelete: () => void;
    expiresAt?: string | null;
    isPendingDelete: boolean;
};

export function TranscriptFooter({
    isOpen,
    onOpenChange,
    onDelete,
    expiresAt,
    isPendingDelete,
}: Props) {
    return (
        <div className="bg-background shrink-0">
            <div className="flex items-center justify-between pr-6 pl-2 h-13">
                <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
                    <AlertDialogTrigger asChild>
                        <Button variant="ghost" size="sm" className="text-xs">
                            <Trash2 className="size-4" />
                            Delete Transcript
                        </Button>
                    </AlertDialogTrigger>
                    <AlertDialogContent>
                        <AlertDialogHeader>
                            <AlertDialogTitle>Delete Transcript?</AlertDialogTitle>
                            <AlertDialogDescription>
                                If you delete this session's transcript, you won't be able to update
                                note parameters or regenerate the note.
                            </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                            <AlertDialogCancel>Cancel</AlertDialogCancel>
                            <AlertDialogAction
                                variant="destructive"
                                onClick={onDelete}
                                disabled={isPendingDelete}
                            >
                                Delete Transcript
                            </AlertDialogAction>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialog>
                {expiresAt && (
                    <p className="text-xs text-right text-muted-foreground">
                        Transcript will be auto-deleted {formatRelativeDays(expiresAt)}
                    </p>
                )}
            </div>
        </div>
    );
}
